import { render } from "./OrganizationLibrary.vue?vue&type=template&id=67b3009a"
import script from "./OrganizationLibrary.vue?vue&type=script&lang=js"
export * from "./OrganizationLibrary.vue?vue&type=script&lang=js"

import "./OrganizationLibrary.vue?vue&type=style&index=0&id=67b3009a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ddv-home/OrganizationLibrary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67b3009a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67b3009a', __exports__)) {
    api.reload('67b3009a', __exports__)
  }
  
  module.hot.accept("./OrganizationLibrary.vue?vue&type=template&id=67b3009a", () => {
    api.rerender('67b3009a', render)
  })

}


export default __exports__